import { useMemo, useState } from 'react';
import { applyFilters } from './applyPipeline';
import type { FilterApplyOptions } from './types';

/**
 * Shared client-side filter state + pipeline for pages with external ScopeTableFilters.
 */
export function useClientFilterPipeline<T extends Record<string, unknown>>(
  base: T[] | undefined,
  options?: FilterApplyOptions
) {
  const [filtersState, setFiltersState] = useState<Record<string, unknown>>({});

  const displayData = useMemo(() => {
    const source = base ?? [];
    if (!filtersState || Object.keys(filtersState).length === 0) {
      return source;
    }
    return applyFilters<T>(source, filtersState, options) ?? source;
  }, [base, filtersState, options]);

  return { filtersState, setFiltersState, displayData };
}
